import { render, staticRenderFns } from "./RegisterAnnual.vue?vue&type=template&id=19c9281d&scoped=true&"
import script from "./RegisterAnnual.vue?vue&type=script&lang=js&"
export * from "./RegisterAnnual.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAnnual.vue?vue&type=style&index=0&id=19c9281d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c9281d",
  null
  
)

export default component.exports